export enum LocalStorageFields {
  IS_LOGGED_IN = 'isLoggedIn',
  MSAL_LOGIN_HINT = 'od-msLoginHint',
  USER_EMAIL = 'userEmail',
  USER_SETTINGS_ID = 'userSettingsId',
  AUTHORITIES = 'authorities',
  ROLES = 'roles',
  KEEP_ALIVE = 'keepAlive',
  GROUPS = 'groups',
  APPLICATIONS = 'applications',
  THEME = 'theme',
  SPEECH_ACTIVE = 'speechActive',
  CHATBOT_AGENT = 'chatbotAgent',
}
